var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[(_vm.pwdChecked)?_c('Editar'):_c('CheckPassword')],1)}
var staticRenderFns = []

export { render, staticRenderFns }